/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CrownIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABU0lEQVR4nOWSPUrEUBCAI4pWghZWFmJh6QHEIp0Es/OTwNuZTeMZLBQPILiWeghBbWxs3UJsvYDYKcgWHkDxh+eabDRZkuymWR0Y3sD8fDNvxnH+jRBtzQFrx6q1awcAawdZP6xae/wAfthaQdZ3q9auHQAs5/EESHpRKRkRZ4lE7JvrD8QkxWMNxOTFEkWrwBL+7I50t9eZ3EPYXE/7PGMWkLSbAZB2rS8VOoEsO0DyYv2bYbSUeBosG8kCSd6A5MjzvJmv7knPMsUTiJzGTQDLZd8nz67rTiUAY8wksjylk4HlFln2BhbvFzv8nYskJ9l/ZjkuLqblNGhqBtDg1lpNgFffj+bzr4n1blQAsF7lFv++pv2RJ0DdHgwAs5xZGFfSB983i87fFmC9GfqLSK5LAORxlB04RYKs7aFPlPSgEGCMmbaQKpNAL7Ztc0vvYmzkE1rzvkpxgJNeAAAAAElFTkSuQmCC)
 */
export const CrownIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M5 18a1 1 0 0 0-1 1 3 3 0 0 0 3 3h10a3 3 0 0 0 3-3 1 1 0 0 0-1-1H5ZM3.04 7.76a1 1 0 0 0-1.52 1.15l2.25 6.42a1 1 0 0 0 .94.67h14.55a1 1 0 0 0 .95-.71l1.94-6.45a1 1 0 0 0-1.55-1.1l-4.11 3-3.55-5.33.82-.82a.83.83 0 0 0 0-1.18l-1.17-1.17a.83.83 0 0 0-1.18 0l-1.17 1.17a.83.83 0 0 0 0 1.18l.82.82-3.61 5.42-4.41-3.07Z"
        className={colorClass}
      />
    </svg>
  );
};
